import React, { useRef, useEffect } from 'react';

import LottieView from 'lottie-react-native';
import PropTypes from 'prop-types';

import FrameworkTestKeys from '../../FrameworkTestKeys';

const PreOnboardingLottie = ({ lottieSource, lottieDurationConfig, activeIndex }) => {
  const lottieRef = useRef();
  useEffect(() => {
    // Or set a specific startFrame and endFrame with:
    lottieRef.current.play(
      lottieDurationConfig[activeIndex].start,
      lottieDurationConfig[activeIndex].end,
    );
  }, [lottieDurationConfig[activeIndex]]);

  return (
    <LottieView
      ref={lottieRef}
      source={lottieSource}
      autoPlay
      loop={false}
      testID={FrameworkTestKeys.PreOnboardingLottieView}
    />
  );
};

PreOnboardingLottie.propTypes = {
  lottieSource: PropTypes.object,
  lottieDurationConfig: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.number,
      end: PropTypes.number,
    }),
  ),
  activeIndex: PropTypes.number,
};

export default PreOnboardingLottie;
